import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@egaranti/components";

import { useTranslation } from "react-i18next";

import EnglishFlag from "../../assets/icons/enFlag.svg?react";
import RussianFlag from "../../assets/icons/ruFlag.svg?react";
import TurkishFlag from "../../assets/icons/turkishFlag.svg?react";
import UzbekFlag from "../../assets/icons/uzFlag.svg?react";

/**
 * EPS-5120 (QA turu) — secili dil adi kirpiliyordu: kutu bombos olmasina ragmen
 * "English" yerine "Engli..." yaziyordu, yalniz "Türkçe" tam gorunuyordu.
 *
 * Sebep paylasilan `SelectTrigger`: sinifinda `[&>span]:line-clamp-1` var, bu da
 * SelectValue'nun span'ini `display:-webkit-box` + `overflow:hidden` yapiyor.
 * Biz o span'in icine `flex` bir `div` koyuyorduk; -webkit-box icindeki blok
 * cocuk gercek genisligini alamadigi icin metin erken kesiliyordu. "Türkçe"
 * dar oldugu icin sigiyor, bayrakla birlikte daha genis olan digerleri tasiyordu.
 *
 * Cozum: span'in kendisi satir ici flex yapiliyor ve line-clamp kapatiliyor;
 * icine ayrica saran bir div konmuyor. Diller ayni zamanda tek bir listeden
 * uretiliyor (ayni dort dal metinde ve baslikta iki kez kopyalanmisti).
 */
const DILLER = [
  { kod: "tr", ad: "Türkçe", Bayrak: TurkishFlag },
  { kod: "en", ad: "English", Bayrak: EnglishFlag },
  { kod: "ru", ad: "Русский", Bayrak: RussianFlag },
  { kod: "uz", ad: "O'zbekcha", Bayrak: UzbekFlag },
];

const LangSwitch = () => {
  const { i18n } = useTranslation();

  // i18n.language "en-US" gibi gelebiliyor; taban koda indiriyoruz.
  const tabanKod = (i18n.language || "").split("-")[0];
  const secili = DILLER.find((d) => d.kod === tabanKod) ?? DILLER[1];
  const { Bayrak } = secili;

  return (
    <div className="mt-2 max-w-sm rounded-lg bg-white">
      <Select
        onValueChange={(kod) => i18n.changeLanguage(kod)}
        value={secili.kod}
      >
        {/*
          `!` sart: kutuphanenin `[&>span]:line-clamp-1` kurali ayni ozellikleri
          yaziyor ve hangisinin kazanacagi uretilen CSS'teki siraya kaliyor.
          `display:flex` kazandigi anda `-webkit-line-clamp` zaten etkisiz kalir
          (yalniz `-webkit-box` ile calisir), `overflow` da acilir.
        */}
        <SelectTrigger className="[&>span]:!flex [&>span]:min-w-0 [&>span]:items-center [&>span]:gap-2 [&>span]:!overflow-visible">
          <SelectValue>
            <Bayrak className="shrink-0" />
            <span className="truncate text-sm">{secili.ad}</span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {DILLER.map(({ kod, ad, Bayrak: Simge }) => (
            <SelectItem key={kod} value={kod}>
              <span className="flex items-center gap-2">
                <Simge className="shrink-0" />
                {ad}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LangSwitch;
